import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { agentClient } from '../lib/connect/clients';
export const MEMORIES_KEY = 'memories';
function toRow(m) {
    if (!m.id) return null;
    return {
        id: m.id,
        kind: m.kind ?? '',
        title: m.title ?? '',
        body: m.body ?? '',
        scopeKind: m.scopeKind ?? '',
        scopeId: m.scopeId ?? '',
        updatedBy: m.updatedBy ?? '',
        updatedAt: m.updatedAt?.toDate?.()
    };
}
async function fetchMemories(scopes) {
    const seen = new Set();
    const rows = [];
    const personal = await agentClient.listMemories({});
    for (const m of personal.memories ?? []){
        const row = toRow(m);
        if (row && !seen.has(row.id)) {
            seen.add(row.id);
            rows.push(row);
        }
    }
    for (const scope of scopes){
        if (!scope.scopeKind || !scope.scopeId) continue;
        const resp = await agentClient.listMemories({
            scopeKind: scope.scopeKind,
            scopeId: scope.scopeId
        });
        for (const m of resp.memories ?? []){
            if (m.kind !== 'project') continue;
            const row = toRow(m);
            if (row && !seen.has(row.id)) {
                seen.add(row.id);
                rows.push(row);
            }
        }
    }
    rows.sort((a, b)=>(b.updatedAt?.getTime() ?? 0) - (a.updatedAt?.getTime() ?? 0));
    return rows;
}
export function useMemories(scopes) {
    const scopeKey = scopes.map((s)=>`${s.scopeKind ?? ''}:${s.scopeId ?? ''}`).join('|');
    return useQuery({
        queryKey: [
            MEMORIES_KEY,
            scopeKey
        ],
        queryFn: ()=>fetchMemories(scopes)
    });
}
export function useUpsertMemory(scopes) {
    const qc = useQueryClient();
    const scopeKey = scopes.map((s)=>`${s.scopeKind ?? ''}:${s.scopeId ?? ''}`).join('|');
    return useMutation({
        mutationFn: async (input)=>agentClient.upsertMemory(input),
        onSuccess: ()=>qc.invalidateQueries({
                queryKey: [
                    MEMORIES_KEY,
                    scopeKey
                ]
            })
    });
}
export function useDeleteMemory(scopes) {
    const qc = useQueryClient();
    const scopeKey = scopes.map((s)=>`${s.scopeKind ?? ''}:${s.scopeId ?? ''}`).join('|');
    return useMutation({
        mutationFn: async (id)=>agentClient.deleteMemory({
                id
            }),
        onSuccess: ()=>qc.invalidateQueries({
                queryKey: [
                    MEMORIES_KEY,
                    scopeKey
                ]
            })
    });
}
export function memoryChipLabel(memories) {
    const titles = memories.map((m)=>m.title.trim()).filter(Boolean).slice(0, 4);
    if (titles.length === 0) return '';
    return `Using: ${titles.join(' · ')}`;
}
